export default __webpack_public_path__ + "static/media/ic_arrow_right.808b6212.svg";